import { matchPath } from 'react-router';

import { PATH } from 'constants/RoutesConstants';
import * as types from 'modules/dealers/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} State */

const initialState = true;

/**
 * @param {State} state
 * @param {import('modules/global/generic.types').LocationChangeAction} action
 */
const onLocationChange = (state, { payload }) => {
  const isMatching = matchPath(PATH.DEALERS.path, payload.location.pathname) !== null;
  return isMatching ? false : state;
};

const afterFetchDealer = () => true;

export default createReducer(initialState, {
  [LOCATION_CHANGE]: onLocationChange,
  [types.DASHBOARD_IS_READY]: afterFetchDealer,
});
